import type { Grant, MeContext } from '@vizit/api';

export function hasGrant(
  context: MeContext,
  role: Grant['role'],
  scopeType: Grant['scopeType'],
  scopeId?: string | null,
): boolean {
  return context.grants.some(
    (grant) =>
      grant.role === role && grant.scopeType === scopeType && (scopeId === undefined || grant.scopeId === scopeId),
  );
}

export function hasRole(context: MeContext, role: Grant['role']): boolean {
  return context.grants.some((grant) => grant.role === role);
}
